// extracted by mini-css-extract-plugin
export default {"zoomControls":"oia-z","zoomControlButton":"pia-z","zoomBanner":"qia-z","bannerButton":"ria-z","imageButton":"sia-z","zoom":"tia-z","zoomContent":"uia-z"};